import { useEffect } from "react";
import { Edit, useForm } from "@refinedev/antd";
import { HttpError } from "@refinedev/core";
import { Form, Select, Space, Typography } from "antd";
import { IconDisplay } from "../../components/IconDisplay";

const PERFORMANCE_GROUPS = [
  { value: "foundation", label: "Foundation" },
  { value: "development", label: "Development" },
  { value: "academy", label: "Academy" },
  { value: "performance", label: "Performance" },
];

export const UserEdit = () => {
  const { formProps, saveButtonProps, query, formLoading } = useForm<
    any,
    HttpError,
    any
  >({
    resource: "user",
    successNotification: (data) => {
      return {
        message: data?.data.message,
        type: "success",
      };
    },
    action: "edit",
  });

  const user = query?.data?.data?.data;

  const { Text } = Typography;

  // The API nests the record under data.data, so refine's automatic initialValues
  // don't reach the field. Preload the Select once the user has loaded.
  useEffect(() => {
    if (user) {
      formProps.form?.setFieldsValue({
        performanceLevel: user.performanceLevel ?? undefined,
      });
    }
  }, [user, formProps.form]);

  // Only the performance group (classification) is editable here. All other user
  // information is shown read-only and is not submitted on save.
  return (
    <Edit
      saveButtonProps={saveButtonProps}
      isLoading={formLoading}
      resource="user"
      mutationMode="optimistic"
      title="Edit User"
    >
      <Space direction="vertical" size="middle" style={{ marginBottom: 24 }}>
        <Space
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 100,
            height: 100,
            border: "1px solid gray",
            borderRadius: "50%",
          }}
        >
          <IconDisplay
            iconURL={user?.profilePictureURL || ""}
            width={100}
            height={100}
            borderRadius="50%"
          />
        </Space>
        <div>
          <Text strong>{user?.fullName}</Text>
          {user?.username ? (
            <div>
              <Text type="secondary">@{user.username}</Text>
            </div>
          ) : null}
        </div>
      </Space>

      <Form {...formProps} layout="vertical">
        <Form.Item
          label="Performance group"
          name="performanceLevel"
          rules={[{ required: true, message: "Select a performance group" }]}
        >
          <Select
            placeholder="Select performance group"
            options={PERFORMANCE_GROUPS}
            style={{ maxWidth: 320 }}
          />
        </Form.Item>
      </Form>
    </Edit>
  );
};
